import { DELIVERY_NOTES_TABLE_COLUMN_ORDER, DELIVERY_NOTES_TABLE_VISIBLE_COLUMNS } from "Shared/services/localstorage.service"
import { DeliveryNoteColumns } from "Features/pages/deliveryNotes/columns/DeliveryNoteColumns"
import { useTable, UseTablePropsBase } from "Shared/hooks/useTable.hook"

export const useDeliveryNotesTable = <T extends { key: string }>(props: UseTablePropsBase<T>) =>
    useTable({
        ...props,
        localStorageKeyVisibleColumns: DELIVERY_NOTES_TABLE_VISIBLE_COLUMNS,
        localStorageKeyColumnOrder: DELIVERY_NOTES_TABLE_COLUMN_ORDER,
        columnToKeepAtEnd: DeliveryNoteColumns.ACTION,
    })
